// src/styles/GlobalStyles.js
import { createGlobalStyle } from 'styled-components';
import { defaultTheme } from './themes/defaultTheme';

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 14px;
    overflow: hidden;
    height: 100%;
  }

  body {
    font-family: ${({ theme }) => theme?.fonts?.primary || defaultTheme.fonts.primary};
    background-color: ${({ theme }) => theme?.colors?.background};
    color: ${({ theme }) => theme?.colors?.text};
    transition: ${({ theme }) => theme?.transitions?.medium} all;
    line-height: 1.5;
    overflow: hidden;
    height: 100%;
  }

  a {
    font-size: 0.875rem;
    color: ${({ theme }) => theme?.colors?.primary};
    text-decoration: none;
    transition: ${({ theme }) => theme?.transitions?.fast} color;

    &:hover {
      color: ${({ theme }) => theme?.colors?.secondary};
      text-decoration: underline;
    }
  }

  h1 {
    font-size: 1.5rem;
    margin-bottom: 0.75rem;
  }

  h2 {
    font-size: 1.25rem;
    margin-bottom: 0.5rem;
  }

  h3 {
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
  }

  p {
    font-size: 0.875rem;
    margin-bottom: 0.75rem;
  }

  .fw-500 {
    font-weight: 500;
  }

  button {
    font-size: 0.875rem;
    padding: 0.375rem 0.75rem;
  }
    /* BUTTON OUTLINE SECONDARY */
.btn-outline-secondary {
  color: ${({ theme }) => theme.colors.secondary} !important;
  border: 1px solid ${({ theme }) => theme.colors.secondary} !important;
  background-color: transparent;

  &:hover,
  &:focus,
  &.active {
    background-color: ${({ theme }) => theme.colors.secondary} !important;
    color: ${({ theme }) => theme.colors.white} !important;
    border-color: ${({ theme }) => theme.colors.secondary} !important;
  }
}

/* BUTTON OUTLINE PRIMARY */
.btn-outline-primary {
  color: ${({ theme }) => theme.colors.primary};
  border: 1px solid ${({ theme }) => theme.colors.primary};
  background-color: transparent;

  &:hover,
  &:focus,
  &.active {
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
  }
}

/* MODAL SUPPORT */
.modal-content {
  background-color: ${({ theme }) => theme.colors.card} !important;
  color: ${({ theme }) => theme.colors.text} !important;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  border: 1px solid ${({ theme }) => theme.colors.border};
  box-shadow: ${({ theme }) => theme.shadows.medium};
  transition: background-color 0.2s ease, color 0.2s ease;
}

.modal-header,
.modal-footer {
  background-color: ${({ theme }) => theme.colors.card} !important;
  color: ${({ theme }) => theme.colors.text} !important;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
}

.modal-body {
  color: ${({ theme }) => theme.colors.text};
}

/* ALERTS */
.alert {
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  padding: 0.75rem 1rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  color: ${({ theme }) => theme.colors.text};
  background-color: ${({ theme }) => theme.colors.card};
}

.alert-primary {
  background-color: ${({ theme }) => theme.colors.primary}22;
  color: ${({ theme }) => theme.colors.primary};
  border-color: ${({ theme }) => theme.colors.primary};
}

.alert-success {
  background-color: ${({ theme }) => theme.colors.success}22;
  color: ${({ theme }) => theme.colors.success};
  border-color: ${({ theme }) => theme.colors.success};
}

.alert-danger {
  background-color: ${({ theme }) => theme.colors.danger}22;
  color: ${({ theme }) => theme.colors.danger};
  border-color: ${({ theme }) => theme.colors.danger};
}

.alert-warning {
  background-color: ${({ theme }) => theme.colors.warning}22;
  color: ${({ theme }) => theme.colors.warning};
  border-color: ${({ theme }) => theme.colors.warning};
}

/* BUTTON COLORS */
.btn-dark {
  background-color: #000;
  color: #fff;
  border: 1px solid #333;

  &:hover,
  &:focus {
    background-color: #111;
    color: #fff;
  }
}

.btn-light {
  background-color: ${({ theme }) => theme.colors.card};
  color: ${({ theme }) => theme.colors.text};
  border: 1px solid ${({ theme }) => theme.colors.border};

  &:hover,
  &:focus {
    background-color: ${({ theme }) => theme.colors.hoverBackground};
    color: ${({ theme }) => theme.colors.text};
  }
}

/* BACKGROUND UTILITIES */
.bg-white {
  background-color: ${({ theme }) => theme.colors.card} !important;
}

.bg-light {
  background-color: ${({ theme }) => theme.colors.lightGray} !important;
}

.bg-dark {
  background-color: #000 !important;
}

.bg-primary {
  background-color: ${({ theme }) => theme.colors.primary} !important;
}

.bg-danger {
  background-color: ${({ theme }) => theme.colors.danger} !important;
}

.bg-success {
  background-color: ${({ theme }) => theme.colors.success} !important;
}

/* TEXT UTILITIES */
.text-white {
  color: ${({ theme }) => theme.colors.white} !important;
}

.text-light {
  color: ${({ theme }) => theme.colors.lightGray} !important;
}

.text-dark {
  color: ${({ theme }) => theme.colors.text} !important;
}

.text-success {
  color: ${({ theme }) => theme.colors.success} !important;
}

.text-danger {
  color: ${({ theme }) => theme.colors.danger} !important;
}

.text-warning {
  color: ${({ theme }) => theme.colors.warning} !important;
}

    .btn-group {
  display: inline-flex;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.shadows.small};
}

.text-default{
color: ${({ theme }) => theme.colors.text}!important;
}
  .btn-success{
  color: ${({ theme }) => theme.colors.white};
  }
.btn-group .btn {
  background-color: ${({ theme }) => theme.colors.card};
  color: ${({ theme }) => theme.colors.text};
  border: 1px solid ${({ theme }) => theme.colors.inputBorder};
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s ease;
  border-right: none; /* remove double borders */
}

.btn-group .btn:last-child {
  border-right: 1px solid ${({ theme }) => theme.colors.inputBorder}; /* restore for last */
}

.btn-group .btn:not(.active):hover,
.btn-group .btn:not(.active):focus {
  background-color: ${({ theme }) => theme.colors.hoverBackground};
  color: ${({ theme }) => theme.colors.text};
  border-color: ${({ theme }) => theme.colors.inputBorder};
  z-index: 1;
}

.btn-group .btn.active,
.btn-group .btn:active {
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  border-color: ${({ theme }) => theme.colors.primary};
  z-index: 2;
}

  .btn {
  font-size: 0.875rem;
  padding: 0.375rem 0.75rem;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  font-weight: 500;
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}

.btn-primary:disabled{
  background-color: ${({ theme }) => theme.colors.disabledBackground}!important;
    color: ${({ theme }) => theme.colors.textSecondary}!important;
}

.btn-primary {
  background-color: ${({ theme }) => theme.colors.button};
  color: ${({ theme }) => theme.colors.buttonText};
  border-color: ${({ theme }) => theme.colors.inputBorder};

  &:hover,
  &:focus {
    background-color: ${({ theme }) => theme.colors.primary};
    border-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
  }
}

.btn-outline-primary {
  background-color: transparent;
  color: ${({ theme }) => theme.colors.primary};
  border-color: ${({ theme }) => theme.colors.primary};

  &:hover,
  &.active,
  &:focus {
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
    border-color: ${({ theme }) => theme.colors.primary};
  }
}
.btn-secondary{
  background-color: ${({ theme }) => theme.colors.secondary}!important;
  color: ${({ theme }) => theme.colors.blankandwhite} !important;
}
.btn-outline-secondary {
  background-color: transparent;
  color: ${({ theme }) => theme.colors.secondary};
  border: 1px solid ${({ theme }) => theme.colors.secondary} !important;
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}

.btn-outline-secondary:hover,
.btn-outline-secondary.active {
  background-color: ${({ theme }) => theme.colors.secondary} !important;
  color: ${({ theme }) => theme.colors.white} !important;
  border-color: ${({ theme }) => theme.colors.secondary} !important;
}

  .btn:disabled,
.btn.disabled {
  opacity: 0.6;
  pointer-events: none;
}

  .text-primary {
    color: ${({ theme }) => theme.colors.primary} !important;
  }
    .text-bg-danger {
  background-color: ${({ theme }) => theme.colors.danger} !important;
  color: ${({ theme }) => theme.colors.white} !important;
}
    .text-dark {
  color: ${({ theme }) => theme.colors.text} !important;
}

 .border {
  border: 1px solid ${({ theme }) => theme.colors.border} !important;
}

.border-primary {
  border: 1px solid ${({ theme }) => theme.colors.primary} !important;
}

.border-muted {
  border: 1px solid ${({ theme }) => theme.colors.textSecondary} !important;
}

.border-light {
  border: 1px solid ${({ theme }) => theme.colors.lightGray} !important;
}

.border-dark {
  border: 1px solid ${({ theme }) => theme.colors.text} !important;
}

  .border-1 {
    border: 1px solid ${({ theme }) => theme.colors.border} !important;
  }

  .text-color {
    color: ${({ theme }) => theme.colors.text} !important;
  }

  .form-switch {
    margin-right: 4px;
  }

  .form-check-input:not(.form-switch) {
    width: 1.4em !important;
    height: 1.4em !important;
  }

  .form-check-input:checked {
    background-color: ${({ theme }) => theme.colors.primary} !important;
    border-color: ${({ theme }) => theme.colors.primary} !important;
  }

  .search-control{
    border-radius: 0px 8px 8px 0px!important;
    border: 1px solid ${({ theme }) => theme.colors.inputBorder} !important;
  }
  .search-control-with-button{
    border-radius: 0px 0px 0px 0px!important;
    border: 1px solid ${({ theme }) => theme.colors.inputBorder} !important;
  }

  .search-group>.form-control{
    border-left-width:0px!important;
  }

  input,
select,
textarea,
.form-control,
.form-select {
  background-color: ${({ theme }) => theme.colors.card};
  color: ${({ theme }) => theme.colors.text};
  border: 1px solid ${({ theme }) => theme.colors.inputBorder};
  border-radius: 4px;
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}

input:focus,
select:focus,
textarea:focus,
.form-control:focus,
.form-select:focus {
  outline: none;
  border: 2px solid ${({ theme }) => theme.colors.focusBorder};
  box-shadow: 0 0 5px ${({ theme }) => theme.colors.focusShadow};
  background-color: ${({ theme }) => theme.colors.card};
  color: ${({ theme }) => theme.colors.text};
}

  input:not([type='checkbox']):not(.no-border):not(.search-control):(.search-control-with-button) {
    border: 1px solid ${({ theme }) => theme.colors.inputBorder} !important;
    border-radius: 4px !important;
  }

  input:not([type='checkbox']):not(.large):not[data-input] {
    padding: 4px 8px !important;
  }

  input.large {
    padding: 6px !important;
  }

  .form-select {
    padding: 4px 8px !important;
  }

  .modal-content {
    transform: scale(0.95);
    opacity: 0;
    animation: fadeInModal 0.3s forwards;
  }

  @keyframes fadeInModal {
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  .liquid-effect-gradient::before {
    content: '';
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    background: linear-gradient(
      45deg,
      ${({ theme }) => theme.colors.primary},
      ${({ theme }) => theme.colors.secondary}
    );
    opacity: 0.1;
    z-index: 0;
    border-radius: inherit;
  }

  .liquid-effect::before {
    content: '';
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    opacity: 0.1;
    z-index: 0;
    border-radius: inherit;
  }

  .custom-tabs .nav-link {
    border-radius: 0.5rem;
    margin: 2px;
    color: ${({ theme }) => theme.colors.primary} !important;
  }

  .custom-tabs .nav-link.active {
    background-color: ${({ theme }) => theme.colors.primary} !important;
    color: ${({ theme }) => theme.colors.white} !important;
  }

  .email-tabs .nav-tabs {
  border-bottom: none;
  gap: 8px;
  display: flex;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.card};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  padding: 0.25rem;
}

.email-tabs .nav-item {
  flex: 1;
}

.email-tabs .nav-link {
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  color: ${({ theme }) => theme.colors.primary};
  background-color: ${({ theme }) => theme.colors.card};
  text-align: center;
  font-weight: 600;
  transition: all 0.2s ease;
}

.email-tabs .nav-link.active {
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
}


  .modal-dialog.dl-modal {
    min-width: 600px !important;
    max-width: 800px !important;
    width: auto !important;
  }

  input:focus {
    outline: none;
    border: 2px solid ${({ theme }) => theme.colors.focusBorder};
    box-shadow: 0 0 5px ${({ theme }) => theme.colors.focusShadow};
  }

  .bootstrap-time-picker {
    width: 100%;
    font-family: inherit;
  }
    .table-light, .table-responsive table td,.table-responsive table th {
  --bs-table-bg:${({ theme }) => theme.colors.background} !important; 
  --bs-table-color: ${({ theme }) => theme.colors.text} !important;
}
  .table-sorticon:not(.active),.table-resizer{
    opacity:0;
  }
    .table-resizer:hover{
      background-color: ${({ theme }) => theme.colors.primary}!important;
      width:5px!important;
    }
  .table-thead:hover .table-sorticon,.table-thead:hover .table-resizer{
    opacity:1;
  }
    .table-sorticon{
      margin-right:4px;
    }
    .can-sort-th:hover, .table-tbody tr:hover{
      background-color: ${({ theme }) => theme.colors.lightGray};
    }
    .table-tbody tr.selected{
        background-color: ${({ theme }) => theme.colors.selected}!important;
    }
    .table-thead th{
      border-bottom: 1px solid ${({ theme }) => theme.colors.inputBorder};
    }
    .table-tbody td .form-check-input[type=checkbox]:not(:checked),.table-thead th .form-check-input[type=checkbox]:not(:checked){
      opacity:0!important;
    }
   .table-tbody tr:hover td .form-check-input[type=checkbox],.table-thead tr:hover th .form-check-input[type=checkbox]{
      opacity:1!important;
    }

  .bootstrap-time-picker .react-time-picker__wrapper {
    border: 1px solid ${({ theme }) => theme.colors.inputBorder};
    border-radius: 0.5rem;
    padding: 0.5rem 0.75rem;
    background-color: ${({ theme }) => theme.colors.background};
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.text};
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    transition: all 0.2s ease;
  }

  .bootstrap-time-picker .react-time-picker__wrapper:hover {
    border-color: ${({ theme }) => theme.colors.hoverBorder};
    background-color: ${({ theme }) => theme.colors.hoverBackground};
  }

  .bootstrap-time-picker .react-time-picker__wrapper:focus-within {
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 0 0.25rem ${({ theme }) => theme.colors.focusRing};
  }

  .bootstrap-time-picker .react-time-picker__inputGroup__input {
    background: transparent;
    border: none;
    outline: none;
    color: ${({ theme }) => theme.colors.text};
    font-weight: 500;
  }

  .bootstrap-time-picker .react-time-picker__inputGroup__divider {
    color: ${({ theme }) => theme.colors.textSecondary};
    padding: 0 2px;
  }

  .bootstrap-time-picker .react-time-picker__button {
    color: ${({ theme }) => theme.colors.primary};
    background: transparent;
    border: none;
    cursor: pointer;
  }

  .bootstrap-time-picker .react-time-picker__clock {
    background-color: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.inputBorder};
    border-radius: 0.5rem;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    z-index: 2000;
  }

    .card {
    background-color: ${({ theme }) => theme.colors.card} !important;
    border: 1px solid ${({ theme }) => theme.colors.border} !important;
    color: ${({ theme }) => theme.colors.text};
    border-radius: ${({ theme }) => theme.borderRadius.medium};
    box-shadow: ${({ theme }) => theme.shadows.small};
    transition: background-color 0.3s ease, color 0.3s ease;
  }

  .card-header,
  .card-footer {
    background-color: ${({ theme }) => theme.colors.card};
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  .card-footer {
    border-top: 1px solid ${({ theme }) => theme.colors.border};
  }

  .card-body {
    padding: 1rem;
    background-color: ${({ theme }) => theme.colors.card};
  }

  .card-title {
    font-size: 1.1rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }

  .card-text {
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.textSecondary};
  }
    .bg-secondary{
    background-color: ${({ theme }) => theme?.colors?.secondary};
    }
    .bg-light-green{
    background-color: rgb(223, 246, 221);
    }
  .bg-gray {
    background-color: ${({ theme }) => theme.colors.lightGray} !important;
  }
  .bg-theme-card {
    background-color: ${({ theme }) => theme.colors.card} !important;
  }

  .empty-outer {
  border: 2px dashed ${({ theme }) => theme.colors.inputBorder};
  border-radius: 10px;
  margin-top: 5px;
  background-color: ${({ theme }) => theme.colors.emptyBackground || '#f9f9f9'};
}

.text-muted-theme {
  color: ${({ theme }) => theme.colors.textSecondary} !important;
}

.badge {
  display: inline-block;
  padding: 0.35em 0.65em;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: ${({ theme }) => theme.borderRadius.small};
}

.role-card:hover {
  box-shadow: 0 0 10px rgba(0, 123, 255, 0.4);
  transform: scale(1.01);
  transition: all 0.2s ease-in-out;
}

.badge-info-subtle {
  background-color: #e7f1fc;
  color: #0d6efd;
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
}

.breadcrumb-container {
  padding: 0.75rem 1rem;
  border-radius: 0.25rem;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;
  list-style: none;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
}

.breadcrumb-item + .breadcrumb-item::before {
  content: "/";
  display: inline-block;
  padding: 0 0.5rem;
  color: ${({ theme }) => theme.colors.textSecondary};
}

.breadcrumb-item a {
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;
}

.breadcrumb-item a:hover {
  text-decoration: underline;
}

.breadcrumb-item.active {
  color: ${({ theme }) => theme.colors.textSecondary};
}

/* Inside GlobalStyles or component.css */

.quill-wrapper .ql-container {
  min-height: 100px;
}

.placeholder-dropdown-wrapper {
  display: flex;
  justify-content: flex-end;
  padding-top: 0.25rem;
}

.placeholder-dropdown-wrapper select {
  font-size: 0.85rem;
}

  /* List Group Styles */
  .list-group {
    border-radius: ${({ theme }) => theme.borderRadius.medium};
    box-shadow: ${({ theme }) => theme.shadows.small};
    background-color: ${({ theme }) => theme.colors.card};
    border: 1px solid ${({ theme }) => theme.colors.border};
  }

  .list-group-item {
    background-color: ${({ theme }) => theme.colors.card};
    color: ${({ theme }) => theme.colors.text};
    border: 1px solid ${({ theme }) => theme.colors.border};
    padding: 0.75rem 1.25rem;
    transition: all ${({ theme }) => theme.transitions.fast};
  }

  .list-group-item:first-child {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
  }

  .list-group-item:last-child {
    border-bottom-left-radius: inherit;
    border-bottom-right-radius: inherit;
  }

  .list-group-item:hover,
  .list-group-item:focus {
    background-color: ${({ theme }) => theme.colors.hoverBackground};
    color: ${({ theme }) => theme.colors.text};
  }

  .list-group-item.active {
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
    border-color: ${({ theme }) => theme.colors.primary};
    z-index: 2;
  }

  .list-group-item.disabled,
  .list-group-item:disabled {
    background-color: ${({ theme }) => theme.colors.disabledBackground};
    color: ${({ theme }) => theme.colors.textSecondary};
    pointer-events: none;
  }

  .list-group-item-action {
    cursor: pointer;
  }

  .list-group-flush .list-group-item {
    border-left: 0;
    border-right: 0;
    border-radius: 0;
  }

  .list-group-flush .list-group-item:first-child {
    border-top: 0;
  }

  .list-group-flush .list-group-item:last-child {
    border-bottom: 0;
  }
  .text-white-black{
    color: ${({ theme }) => theme.colors.whiteandblack};
  }
  .text-black-white{
    color: ${({ theme }) => theme.colors.blankandwhite};
  }

  .custom-offcanvas-header .btn-close {
  filter: invert(1); /* Inverts the default black to white */
  opacity: 1;
}

.audit-header .btn-close {
  position: fixed;
  right: 20px;
  top: 24px;
  z-index: 200000;
  opacity: 1;
  background-color: transparent;
  background-image: ${({ theme }) => {
    const color = encodeURIComponent(theme.colors.blankandwhite);
    return `url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='${color}' viewBox='0 0 16 16'><path d='M2.146 2.146a.5.5 0 0 1 .708 0L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854a.5.5 0 0 1 0-.708z'/></svg>")`;
  }};
  background-size: 1.25em;
}


.audit-instance-badge {
  font-size: 0.75rem;
  border: 1px solid ${({ theme }) => theme.colors.transparentBoder};
  border-radius: 0.25rem;
  background-color: ${({ theme }) => theme.colors.auditbadge};
  color: ${({ theme }) => theme.colors.auditbadgecolor};
  font-weight: 500;
}
 .dropdown-no-scroll {
        max-height: unset !important;
        overflow: visible !important;
      }

.dropdown-item:hover,.dropdown-item.active{
  background-color: ${({ theme }) => theme.colors.selected};
}

::-webkit-scrollbar {
    width: 8px;
}

::-webkit-scrollbar-track {
    background: transparent;
}

::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.blankandwhite};
    border-radius: 4px;
    transition: background-color 0.3s;
}

::-webkit-scrollbar-thumb:hover {
    background-color: ${({ theme }) => theme.colors.blankandwhite};
}
    
.guide-icon {
  display: inline-block;
  font-size: 1.2rem;  
  border: none;
  outline: none;
  background: transparent;
}
  .guide-icon:hover{
    animation: bounce-glow 1s infinite ease-in-out;
  }

.guide-icon:focus,
.guide-icon:active {
  outline: none;
  box-shadow: none;
}

@keyframes bounce-glow {
  0%, 100% {
    transform: translateY(0);
    filter: drop-shadow(0 0 0 rgba(0, 128, 0, 0));
  }
  30% {
    transform: translateY(-5px);
    filter: drop-shadow(0 0 10px rgba(0, 128, 0, 0.6));
  }
  60% {
    transform: translateY(2px);
    filter: drop-shadow(0 0 6px rgba(0, 128, 0, 0.4));
  }
}
.clear-icon:hover {
      color: #333;
      background-color: #eee;
    }


`;
